import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { lighten, darken, rgba } from 'polished';
import { Slider } from '@mui/material';
import { primaryColor } from '../../utils/helpers';
import { palette } from '../design-system';
import { Card } from 'reactstrap';
const { REACT_APP_STATIC_PREFIX = '/static' } = import.meta.env;
import { ThemedButton } from './themed-button/ThemedButton';

export const DebugPrimary = styled.span`
    content: ${(props) => props.theme.primary};
`;

export const DebugSecondary = styled.span`
    content: ${(props) => props.theme.secondary};
`;

export const DebugColors = () => {
    const theme = useTheme();
    return (
        <div>
            primary: {(theme && theme.primary) || 'nothing'} <DebugPrimary />
            <br />
            secondary: {(theme && theme.secondary) || 'nothing'}{' '}
            <DebugSecondary />
            <br />
        </div>
    );
};

export const ThemedText = styled.span`
    color: ${(props) => primaryColor(props)};
`;

export const ThemedBigText = styled(ThemedText)`
    font-size: 1.4em;
    font-weight: 700;
`;

export const ThemedCertificateButton = styled(ThemedButton)`
    flex: 1;
    margin-top: 10px;
    background: ${(props) => primaryColor(props)};
    line-height: 24px;
    font-size: 18px;
    font-weight: 700;
    color: white;
    padding-left: 0px;
    padding-right: 23px;
    min-width: 400px;
    margin: 10px auto 0 auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    position: relative;
    overflow: visible;
    transition: ease 0.2s background;
    border: none;
    &:hover {
        background: ${(props) => lighten(0.1, primaryColor(props))}
        &:after {
            background-size: 34px auto;
        }
    }
    @media (max-width: 899px) {
        max-width: 96%;
        min-width: unset;
        padding-left: 20px;
        padding-right: 60px;

    }
    &:after {
        content: "";
        transition: ease 0.2s background;

        position: absolute;
        background: url('${REACT_APP_STATIC_PREFIX}/img/icon-send.svg') no-repeat center center;
        background-size: 32px auto;
        right: 14px;
        top: 4px;
        height: 44px;
        width: 44px;
    }
`;

export const ThemedSlider = styled(Slider)`
    color: ${(props) => primaryColor(props)};
`;

export const ThemedStep = styled.span`
    white-space: nowrap;
    font-size: 14px;
    color: ${rgba(palette.graphite.heavyMetal, 0.2)};
    font-weight: 800;
    text-transform: uppercase;
    color: ${lighten(0.6, palette.graphite.heavyMetal)};
    font-weight: 700;
    border-left-color: white;
    border-left-style: solid;
    border-left-width: 4px;
    border-right-color: white;
    justify-content: space-between;
    flex-direction: row;
    display: flex;
    letter-spacing: 0.04em;
    padding-right: 20px;
    a {
        width: 100%;
    }
    &:after {
        position: absolute;
        content: '';
        width: 20px;
        height: 36px;
        right: 0px;
        top: 0px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 14px auto;
        transition: ease 0.2s all;
    }

    ${(props) =>
        props.enabled &&
        !props.active &&
        css`
            cursor: pointer;
            color: ${palette.graphite.heavyMetal};
            &:hover {
                color: ${(props) => lighten(0.1, primaryColor(props))};
                border-left-color: ${lighten(0.4, palette.graphite.heavyMetal)};
                border-right-color: ${lighten(0.4, palette.graphite.heavyMetal)};
            }
            &:after {
                position: absolute;
                content: '';
                width: 20px;
                height: 36px;
                right: 0px;
                top: 0px;
                background-size: 14px auto;
            }
        `};
    ${(props) =>
        props.active &&
        css`
            border-left-color: ${(props) => primaryColor(props)};
            border-right-color: ${(props) => primaryColor(props)};
            border-left-style: solid ${(props) => primaryColor(props)};
            border-left-width: 4px;
            a {
                color: ${(props) => primaryColor(props)};
                font-weight: 800;
            }
            span {
                font-weight: 600;
            }
        `};
    ${(props) =>
        props.viewed &&
        css`
            &:after {
                background-image: url('${REACT_APP_STATIC_PREFIX}/img/icon-subject-inprogress.svg');
            }
            &.answered {
                &:after {
                    background-image: url('${REACT_APP_STATIC_PREFIX}/img/icon-subject-completed.svg');
                }
            }
        `};
`;

export const ThemedCard = styled(Card)`
    ${(props) =>
        props.selected &&
        css`
            color: ${(props) => props.color || props.theme.primary};
            background-color: ${(props) =>
                rgba(props.color || props.theme.primary, 0.05)};
            border-color: ${(props) => props.color || props.theme.primary};
        `}
`;
